import { c as _c } from "react/compiler-runtime";
import { useFetchers } from "@website/fetcher/use-fetcher";
import { ReserveCommentPropertiesType } from "@website/widget/reserve-comment";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { fetchHotelReviewData } from "./index.server";
export const useHotelComments = properties => {
  const $ = _c(23);
  const router = useRouter();
  const t0 = String(router.query?.filter_attitude === "all" ? "" : router.query?.filter_attitude ?? "") || "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      attitude: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialFilters = t1;
  const {
    hotelId,
    roomId
  } = properties;
  const total = useRef(0);
  const page = useRef(1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [1];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [pages, setPages] = useState(t2);
  const [filters, setFilters] = useState(initialFilters);
  let t3;
  if ($[3] !== filters || $[4] !== hotelId || $[5] !== pages || $[6] !== roomId) {
    t3 = pages?.map(page_0 => ({
      queryKey: ["hotelReviewData", hotelId, page_0, "villa", filters, roomId],
      queryFn: _temp
    }));
    $[3] = filters;
    $[4] = hotelId;
    $[5] = pages;
    $[6] = roomId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      queries: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const commentsQueries = useFetchers(t4);
  let t5;
  let t6;
  if ($[10] !== commentsQueries) {
    t5 = () => {
      page.current = commentsQueries.flatMap(_temp2)?.[commentsQueries.length - 1];
      total.current = commentsQueries.flatMap(_temp3)?.[commentsQueries.length - 1];
    };
    t6 = [commentsQueries];
    $[10] = commentsQueries;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      if (page.current < Math.ceil(total.current / 5)) {
        setPages(previousState => [...previousState, page.current + 1]);
      }
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const onLoadMore = t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = filter => {
      if (filter?.attitude === "all") {
        filter.attitude = "";
      }
      setFilters(previousState_0 => ({
        ...previousState_0,
        ...filter
      }));
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const onLoadFilter = t8;
  let t9;
  if ($[15] !== commentsQueries) {
    t9 = commentsQueries.flatMap(_temp4) as unknown as Array<ReserveCommentPropertiesType> || [];
    $[15] = commentsQueries;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== commentsQueries) {
    t10 = commentsQueries.some(_temp5);
    $[17] = commentsQueries;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== initialFilters || $[20] !== t10 || $[21] !== t9) {
    t11 = {
      onLoadMore,
      onLoadFilter,
      filters: initialFilters,
      comments: t9,
      isLoading: t10
    };
    $[19] = initialFilters;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
function _temp(t0) {
  const {
    queryKey
  } = t0;
  return fetchHotelReviewData(queryKey[1], queryKey[2], String(queryKey[3]), queryKey[4] as Record<string, string>);
}
function _temp2(t0) {
  const {
    data
  } = t0;
  return data?.page;
}
function _temp3(t0) {
  const {
    data: data_0
  } = t0;
  return data_0?.total;
}
function _temp4(t0) {
  const {
    data: data_1
  } = t0;
  return data_1?.rateReviews || [];
}
function _temp5(item) {
  return item.isFetching;
}